import React, { useEffect, useRef, useState } from "react";
import Default from "../../components/defaults/Default";
import { NavLink, useLocation, useParams } from "react-router-dom";

import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import * as am5radar from "@amcharts/amcharts5/radar";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import PieChart from "../../components/PieChart";

import html2canvas from "html2canvas";
import jsPDF from "jspdf";

import Swal from "sweetalert2";

import { RiSendPlaneLine, RiDownloadLine, RiLoader2Line } from "react-icons/ri";
import Moment from "react-moment";
import PostRequest from "../../servies/PostRequest";
import { LOGO_BLACK, LOGO_BLUE } from "../../images";
import ResponsePDF from "./ReportPDF";
import { pdf } from "@react-pdf/renderer";
import moment from "moment";
const ResponseDetails = () => {
  const location = useLocation();

  const params = useParams();
  const formId = params.form || "t0DoMPhK";

  const [chartStateData, setChartStateData] = useState(location.state || null);
  const chartRef = useRef(null);
  const answerRef = useRef(null);

  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingMail, setIsLoadingMail] = useState(false);

  var total = 0;

  const sevenDimentionForms = [
    {
      name: "Physical",
      question: {
        title:
          "What is standing between you and your highest level of physical health?",
        id: "BMqtxPZKDAPl",
      },
      answer: {
        title:
          "What actions are clearly necessary for you to improve your physical health?",
        id: "XCo8VBhD4Byk",
      },
    },

    {
      name: "Emotional",
      question: {
        title: "What are your biggest challenges in the emotional dimension?",
        id: "4NxiU2U6QIaU",
      },
      answer: {
        title:
          "What can you do to increase your current level of emotional mastery?",
        id: "M7JrxXZlefFo",
      },
    },

    {
      name: "Mental",
      question: {
        title:
          "On your way to mastery, what challenges do you expect to face in the mental dimension?",
        id: "Jt5N9x3Yvzbl",
      },
      answer: {
        title:
          "What do you need in order to change, improve, or evolve further in the mental dimension?",
        id: "Mh1hMjcmRnW3",
      },
    },

    {
      name: "Compassion & Intuition",
      question: {
        title:
          "What challenges do you face on your way to mastering the dimension of compassion & intuition?",
        id: "BzoAdwrbROsB",
      },
      answer: {
        title:
          "What must you do to improve your sense of compassion and develop your intuition?",
        id: "7L8bjowoBSGD",
      },
    },

    {
      name: "Will & Talent",
      question: {
        title: "What challenges do you face in the dimension of will & talent?",
        id: "UzoUm8C7hz6w",
      },
      answer: {
        title:
          "What can you do to improve the strength of and your connection to your will & talent?",
        id: "Udv8LovY3wZk",
      },
    },

    {
      name: "Soul",
      question: {
        title:
          "What challenges do you expect to face when navigating the soul dimension?",
        id: "bRnrkQtHPiAA",
      },
      answer: {
        title:
          "What can you do to improve your connection with and understanding of your soul?",
        id: "EYQkY9gY2y4o",
      },
    },
  ];

  const eightAspectsForm = [
    {
      name: "Self-Mastery",
      question: {
        title:
          "What challenges do you expect to face on your way to self-mastery?",
        id: "N0IhHq4uRiu5",
      },
      answer: {
        title:
          "What improvements in the four areas of intelligence (PQ, EQ, IQ, SQ) will help you on your way to self-mastery?",
        id: "c3WhVfP4xV9a",
      },
    },

    {
      name: "Relationships",
      question: {
        title:
          "What challenges do you face in managing your current relationships?",
        id: "xP1pZj5H9vZr",
      },
      answer: {
        title: "What can you do to improve your relationships?",
        id: "rfR7ebCyW3WU",
      },
    },

    {
      name: "Fitness & Longevity",
      question: {
        title:
          "What challenges do you face in terms of reaching/maintaining your Fitness & Longevity goals?",
        id: "eAbJXHrVRoEs",
      },
      answer: {
        title:
          "What can you do to improve your overall level of Fitness & Longevity and achieve your goals?",
        id: "F7C00JZAZhBV",
      },
    },
    {
      name: "Purpose, Mission & Career",
      question: {
        title:
          "What challenges do you expect to face as you advance toward actualizing your Purpose, Mission & Career?",
        id: "s4VESQ7OVqfB",
      },
      answer: {
        title:
          "What can you do right now to improve the situation surrounding your Purpose, Mission & Career?",
        id: "F7C00JZAZhBV",
      },
    },
    {
      name: "Finances",
      question: {
        title:
          "What challenges do you expect to face as you work to master your Finances?",
        id: "vZRofTiIjQNQ",
      },
      answer: {
        title:
          "What can you do right now to improve your current economic situation?",
        id: "ESrNqCZNCddq",
      },
    },
    {
      name: "Mentors & Allies",
      question: {
        title:
          "What challenges are you experiencing in finding and cultivating Mentors & Allies?",
        id: "cNFOpkp9oAej",
      },
      answer: {
        title:
          "What can you do to improve your situation surrounding mentors/mentorship?",
        id: "cHLcNVu31C6x",
      },
    },
    {
      name: "Life Management",
      question: {
        title:
          "What challenges do you face in the cultivation your ideal Life Management?",
        id: "VAGVFPNg6dQs",
      },
      answer: {
        title: "What can you do right now to improve your Life Management?",
        id: "LQRppnsd1hYk",
      },
    },
    {
      name: "Service",
      question: {
        title: "What challenges do you face in being of service?",
        id: "dChFCVlENfgO",
      },
      answer: {
        title:
          "What can do right now to increase your level of service and positive impact?",
        id: "fqH6k3vRppfJ",
      },
    },
  ];

  const showSwal = () => {
    Swal.fire({
      icon: "success",
      title: "",
      text: "Automation Mail has been send successfully",
    });
  };

  const _getFieldData = (id, data = false) => {
    if (!data) data = chartStateData;

    if (!data) return "-";

    const value = data?.answers?.find((answer) => answer.field.id == id);
    if (!value) return "-";

    if (value.type == "number") {
      total = total + value[value.type];
    }

    return value[value.type];
  };

  const loadFormDetails = async () => {
    try {
      const formUrl = window.localStorage.getItem("token")
        ? "/form/response"
        : "/form/response/public";
      const response = await PostRequest(formUrl, { formId, query: params.id });
      if (!response) throw new Error("Oops! Something went wrong");

      setChartStateData(response.formResponse);
    } catch (error) {
      alert(error.message);
    }
  };

  useEffect(() => {
    loadFormDetails();
  }, [formId, params.id]);

  useEffect(() => {
    if (!chartStateData) return;

    try {
      let root = am5.Root.new("chartdiv");

      root.setThemes([am5themes_Animated.new(root)]);

      let data = [
        {
          category: "Self-Mastery",
          value1: 10 * _getFieldData("FPutNk6wkT8x", chartStateData),
        },
        {
          category: "Fitness & Longevity",
          value1: 10 * _getFieldData("4Be5vXndJd6j", chartStateData),
        },
        {
          category: "Relationships",
          value1: 10 * _getFieldData("loCxEU3T7h56", chartStateData),
        },

        {
          category: "Life Management",
          value1: 10 * _getFieldData("WiRRHHWxAKja", chartStateData),
        },
        {
          category: "Purpose, Mission & Career",
          value1: 10 * _getFieldData("xmO0RCLZdDSm", chartStateData),
        },
        {
          category: "Finances",
          value1: 10 * _getFieldData("MfJohx51tUeZ", chartStateData),
        },
        {
          category: "Mentors & Allies",
          value1: 10 * _getFieldData("E7RxP18YEF3q", chartStateData),
        },

        {
          category: "Service",
          value1: 10 * _getFieldData("LZWrnfJG9ML5", chartStateData),
        },
      ];

      // Create chart
      let chart = root.container.children.push(
        am5radar.RadarChart.new(root, {
          panX: false,
          panY: false,
          wheelX: "none",
          wheelY: "none",
          innerRadius: am5.percent(58),
          zIndex: 1,
        }),
      );

      // Add cursor
      let cursor = chart.set(
        "cursor",
        am5radar.RadarCursor.new(root, {
          behavior: "none",
        }),
      );

      cursor.lineY.set("visible", false);

      // Create axes and their renderers
      let xRenderer = am5radar.AxisRendererCircular.new(root, {
        cellStartLocation: 0,
        cellEndLocation: 1,
        stroke: "#deff00",
        strokeWidth: 1,
        strokeDasharray: [0.5, 0.5],
      });

      xRenderer.labels.template.setAll({
        radius: 10,
      });

      let xAxis = chart.xAxes.push(
        am5xy.CategoryAxis.new(root, {
          categoryField: "category",
          renderer: xRenderer,
        }),
      );

      xAxis.data.setAll(data);

      xAxis.get("renderer").labels.template.setAll({
        fill: "#011435",
        fontSize: 16,
      });

      const defaultConf = {
        draggable: false,
        dx: -14,
        strictMinMaxSelection: true,
        min: 0,
        max: 100,
        strictMinMax: true,
        renderer: am5radar.AxisRendererRadial.new(root, {
          axisAngle: 1.5,
          tooltipLocation: 0.5,
          minGridDistance: 10,
        }),
      };

      // Create the four radial axes
      let yAxis0 = chart.yAxes.push(am5xy.ValueAxis.new(root, defaultConf));

      let yAxis90 = chart.yAxes.push(
        am5xy.ValueAxis.new(root, {
          ...defaultConf,
          renderer: am5radar.AxisRendererRadial.new(root, {
            axisAngle: 89,
            axisLength: am5.percent(100),
            tooltipLocation: 0.5,
            minGridDistance: 10,
          }),
        }),
      );

      let yAxis180 = chart.yAxes.push(
        am5xy.ValueAxis.new(root, {
          ...defaultConf,
          renderer: am5radar.AxisRendererRadial.new(root, {
            axisAngle: 178.5,
            axisLength: am5.percent(100),
            tooltipLocation: 0.5,
            minGridDistance: 10,
          }),
        }),
      );

      let yAxis270 = chart.yAxes.push(
        am5xy.ValueAxis.new(root, {
          ...defaultConf,
          renderer: am5radar.AxisRendererRadial.new(root, {
            axisAngle: 271,
            axisLength: am5.percent(100),
            tooltipLocation: 0.5,
            minGridDistance: 10,
          }),
        }),
      );

      // Customize axis label colors
      [yAxis0, yAxis90, yAxis180, yAxis270].forEach((axis) => {
        axis
          .get("renderer")
          .labels.template.adapters.add("fill", (fill, target) => {
            return "#011435"; // Adjust label color as needed
          });

        axis
          .get("renderer")
          .labels.template.adapters.add("fontSize", (fill, target) => {
            return 12; // Adjust label color as needed
          });

        axis
          .get("renderer")
          .labels.template.adapters.add("fontWeight", (fill, target) => {
            return "bold"; // Adjust label color as needed
          });

        axis
          .get("renderer")
          .labels.template.adapters.add("text", function (text, target) {
            if (Number(text) % 20 == 0) {
              return text;
            } else {
            }
            return "";
          });
      });

      const myTheme = am5.Theme.new(root);

      myTheme.rule("Grid").setAll({
        // stroke: "#deff00",
        stroke: "#011435",
        // stroke: "#D3A54E",
        strokeDasharray: [0.5, 0.5],
      });

      root.setThemes([myTheme]);

      const _getAxis = (i) => {
        switch (i) {
          case 1:
            return yAxis0;

          case 2:
            return yAxis90;

          case 3:
            return yAxis180;

          case 4:
            return yAxis270;

          default:
            return yAxis0;
        }
      };

      // Create series
      for (var i = 1; i <= 1; i++) {
        let series = chart.series.push(
          am5radar.RadarColumnSeries.new(root, {
            name: "Series " + i,
            xAxis: xAxis,
            yAxis: _getAxis(i),
            valueYField: "value" + i,
            categoryXField: "category",
            fill: "#d3a44eab",
          }),
        );
        series.columns.template.setAll({
          tooltipText: "{categoryX}: {valueY}",
          width: am5.percent(100),
          tooltipHTML: "<p style='color: #000'>{categoryX}: {valueY}</p>",
        });

        series.columns.template.adapters.add("fill", function (fill, target) {
          // Customize the fill color based on the category

          if (
            ["Economics", "Service", "Fitness", "Lifestyle"].indexOf(
              target.dataItem.dataContext.category,
            ) !== -1
          ) {
            return "#d3a44eda";
          }

          return fill;
        });

        series.data.setAll(data);
        series.appear(1000);
      }

      // Animate chart
      chart.appear(1000, 100);

      return () => root.dispose();
    } catch (error) {
      console.log("Error in amchart", error);
    }
  }, [chartStateData]);

  // const convertToPDF = async (isDownload = false) => {
  //   if (isLoading) return false;

  //   try {
  //     setIsLoading(true);

  //     // Wait for chart to fully render
  //     await new Promise((resolve) => setTimeout(resolve, 500));

  //     // Capture the entire card for PDF
  //     const card = document.getElementById("pdf-card");
  //     const cardRect = card.getBoundingClientRect();
  //     const cardCanvas = await html2canvas(card, {
  //       backgroundColor: "#fff",
  //       useCORS: true,
  //       scale: 1.5,
  //       width: cardRect.width,
  //       height: cardRect.height,
  //     });

  //     // Crop the top gap, but add back 50px to avoid cutting off the chart
  //     const estimatedTopGap = Math.floor(cardCanvas.height * 0.2);
  //     let cropTop = Math.floor(estimatedTopGap * 0.8) - 50;
  //     if (cropTop < 0) cropTop = 0;
  //     const cropHeight = cardCanvas.height - cropTop;
  //     const croppedCanvas = document.createElement("canvas");
  //     croppedCanvas.width = cardCanvas.width;
  //     croppedCanvas.height = cropHeight;
  //     const ctx = croppedCanvas.getContext("2d");
  //     ctx.drawImage(
  //       cardCanvas,
  //       0,
  //       cropTop,
  //       cardCanvas.width,
  //       cropHeight,
  //       0,
  //       0,
  //       cardCanvas.width,
  //       cropHeight,
  //     );
  //     const cardImage = croppedCanvas.toDataURL("image/png");

  //     // Capture answers section
  //     const answerImage = await html2canvas(answerRef.current, {
  //       backgroundColor: "#fff",
  //       useCORS: true,
  //       scale: 1.5,
  //     }).then((canvas) => canvas.toDataURL("image/png"));

  //     // Create a PDF document
  //     const pdf = new jsPDF({ orientation: "l" });

  //     // Set white background
  //     pdf.setFillColor(255, 255, 255);
  //     pdf.rect(
  //       0,
  //       0,
  //       pdf.internal.pageSize.width,
  //       pdf.internal.pageSize.height,
  //       "F",
  //     );

  //     // Card image size (reduce chart size in PDF)
  //     const pageWidth = pdf.internal.pageSize.getWidth();
  //     const pageHeight = pdf.internal.pageSize.getHeight();
  //     // Reduce the width for the chart in PDF (e.g. 450px max)
  //     const cardWidth = Math.min(pageWidth - 20, 450);
  //     const cardHeight = (cropHeight / cardCanvas.width) * cardWidth;
  //     pdf.addImage(
  //       cardImage,
  //       "PNG",
  //       10,
  //       10,
  //       cardWidth,
  //       cardHeight,
  //       undefined,
  //       "FAST",
  //     );

  //     // Answers image size
  //     const answerImgHeight = (answerRef.current.clientHeight * 25.4) / 96;
  //     const pagecount = Math.ceil(answerImgHeight / pageHeight);

  //     if (pagecount > 0) {
  //       var j = 0;

  //       console.log(" -(j * pageHeight)", pagecount);

  //       while (j != pagecount) {
  //         pdf.addPage("l", "mm", "a4");
  //         pdf.rect(
  //           0,
  //           0,
  //           pdf.internal.pageSize.width,
  //           pdf.internal.pageSize.height,
  //           "F",
  //         );
  //         pdf.setFillColor(0, 0, 0); //
  //         pdf.addImage(
  //           answerImage,
  //           "PNG",
  //           0,
  //           -(j * pageHeight),
  //           undefined,
  //           undefined,
  //           undefined,
  //           "FAST",
  //         );
  //         j++;
  //       }
  //     }

  //     // pdf.addPage();
  //     // pdf.addImage(answerImage, 'PNG', 0, 0);

  //     if (!isDownload) {
  //       try {
  //         var pdfBlob = pdf.output("blob"); // Get the PDF as a Blobs
  //         // Save or open the PDF
  //         //

  //         var formData = new FormData();
  //         formData.append("pdf", pdfBlob);
  //         formData.append("name", _getFieldData("0YMrCEqzAsQc"));
  //         formData.append("email", _getFieldData("YhEx9aMSUXej"));
  //         formData.append("formId", formId);
  //         formData.append("query", params.id);
  //         const response = await PostRequest("/form/send-mail", formData, true);
  //         console.log("response", response);
  //         showSwal();
  //       } catch (error) {
  //         console.log("Err", error);
  //       }
  //     } else {
  //       pdf.save(`${_getFieldData("0YMrCEqzAsQc", chartStateData)}.pdf`);
  //     }
  //   } catch (error) {
  //     alert(error.message);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const captureChartImage = async () => {
    const canvas = await html2canvas(document.getElementById("pdf-card"), {
      backgroundColor: "#fff",
      scale: 2,
      useCORS: true,
    });
    return canvas.toDataURL("image/png");
  };
  const buildSevenDimensions = () =>
    sevenDimentionForms.map((item) => ({
      name: item.name,
      q1: item.question.title,
      a1: _getFieldData(item.question.id),
      q2: item.answer.title,
      a2: _getFieldData(item.answer.id),
    }));

  const buildEightAspects = () =>
    eightAspectsForm.map((item) => ({
      name: item.name,
      q1: item.question.title,
      a1: _getFieldData(item.question.id),
      q2: item.answer.title,
      a2: _getFieldData(item.answer.id),
    }));

  const convertToPDF = async (isDownload = false) => {
    if (isLoading) return;
    if (isLoadingMail) return;
    if (isDownload) {
      setIsLoading(true);
    } else {
      setIsLoadingMail(true);
    }

    try {
      const chartImage = await captureChartImage();

      const blob = await pdf(
        <ResponsePDF
          chartImage={chartImage}
          sevenDimensions={buildSevenDimensions()}
          eightAspects={buildEightAspects()}
          userName={_getFieldData("0YMrCEqzAsQc")}
          submittedDate={chartStateData?.submitted_at}
        />,
      ).toBlob();

      if (!isDownload) {
        try {
          var formData = new FormData();
          formData.append("pdf", blob);
          formData.append("name", _getFieldData("0YMrCEqzAsQc"));
          formData.append("email", _getFieldData("YhEx9aMSUXej"));
          formData.append("formId", formId);
          formData.append("query", params.id);
          const response = await PostRequest("/form/send-mail", formData, true);
          console.log("response", response);
          alert("Mail sent successfully!");
        } catch (error) {
          console.log("Err", error);
        }
      } else {
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${_getFieldData("0YMrCEqzAsQc", chartStateData)}_${moment(chartStateData?.submitted_at).format("YYYY-MM-DD")}.pdf`;
        a.click();
      }
    } catch (error) {
      alert(error.message);
    } finally {
      if (isDownload) {
        setIsLoading(false);
      } else {
        setIsLoadingMail(false);
      }
    }
  };

  if (!chartStateData) return <div>Loading...</div>;

  return (
    <Default>
      <div className="page-body">
        {/* Container-fluid starts*/}
        <div className="container-fluid ecommerce-page">
          <div className="row">
            <div className="col-xl-12 col-lg-12 mb-3 mt-3">
              <div className="d-flex justify-content-end">
                <button
                  onClick={() => convertToPDF(true)}
                  className="btn btn-dark btn-sm me-3"
                >
                  <div className="d-flex align-items-center">
                    {isLoading ? (
                      <RiLoader2Line className="me-2 fa-spin" size={16} />
                    ) : (
                      <RiDownloadLine className="me-2" size={16} />
                    )}
                    Download PDF
                  </div>
                </button>

                {/* {typeof window !== "undefined" &&
                  window.localStorage.getItem("token") && ( */}
                  <button
                    onClick={() => convertToPDF(false)}
                    className="btn btn-dark btn-sm"
                  >
                    <div className="d-flex align-items-center">
                      {isLoadingMail ? (
                        <RiLoader2Line className="me-2 fa-spin" size={16} />
                      ) : (
                        <RiSendPlaneLine className="me-2" size={16} />
                      )}
                      Send Automation Mail
                    </div>
                  </button>
                  {/* )} */}
              </div>
            </div>

            <div className="col-xl-12 col-lg-12">
              <div className="card chart-container">
                <div className="p-4 text-black">
                  <h4> SEOL Map Assessment </h4>
                  <div>
                    <label className="name"> Name : </label>{" "}
                    <label>
                      {" "}
                      {_getFieldData("0YMrCEqzAsQc", chartStateData)}{" "}
                    </label>
                  </div>
                  <div>
                    <label className="date"> Date : </label>{" "}
                    <Moment
                      format="YYYY-MM-DD"
                      date={chartStateData.submitted_at}
                    />
                  </div>
                </div>
                <div
                  id="pdf-card"
                  style={{
                    width: "900px",
                    height: "900px",
                    margin: "0 auto",
                    paddingBottom: "120px",
                  }}
                >
                  <div
                    ref={chartRef}
                    style={{ position: "relative" }}
                    className="card-body"
                  >
                    <div className="bottom-logo">
                      <img src={LOGO_BLUE} height={15} />{" "}
                    </div>

                    <div
                      id="chartdiv"
                      style={{
                        width: "100%",
                        height: "800px",
                        position: "relative",
                        zIndex: 999999,
                      }}
                    ></div>
                    <div className="chart-inner-details text-center d-flex justify-content-center">
                      <div className="chart-inner">
                        <div>
                          <div className="pt">PQ</div>
                          <div className="Discipline">Discipline</div>
                          <div className="sq">SQ</div>
                          <div className="Charisma">Charisma</div>
                          <div className="eq">EQ</div>
                          <div className="Creativity">Creativity</div>
                          <div className="iq">IQ</div>
                          <div className="Systematic">Systematic</div>
                        </div>

                        <div className="circle-one"></div>

                        <div className="circle-two_main"></div>
                        <div className="circle-two"></div>

                        <div className="circle-three">
                          <div className="value">
                            {_getFieldData("Ikb6HjpMxk0J", chartStateData)}
                          </div>
                          <div className="kd-label">Physical</div>
                        </div>

                        <div className="circle-four">
                          <div className="value">
                            {_getFieldData("2BLVFgtbVwU6", chartStateData)}
                          </div>
                          <div className="kd-label">Emotional</div>
                        </div>

                        <div className="circle-five">
                          <div className="value">
                            {_getFieldData("cmc5Db6apZLK", chartStateData)}
                          </div>
                          <div className="kd-label">Mental</div>
                        </div>

                        <div className="circle-six">
                          <div className="value">
                            {_getFieldData("M9cAAvXbFGGm", chartStateData)}
                          </div>
                          <div className="kd-label">Compassion</div>
                        </div>

                        <div className="circle-seven">
                          <div className="value">
                            {_getFieldData("yUccMNP0rs5I", chartStateData)}
                          </div>
                          <div className="kd-label">Will & Talent</div>
                        </div>

                        <div className="circle-eight">
                          <div className="value">
                            {_getFieldData("qLDvaDPVFRDo", chartStateData)}
                          </div>
                          <div className="kd-label">Soul</div>
                        </div>

                        <div className="circle-nines">
                          <div>{total}</div>
                          <div
                            style={{
                              fontSize: 9,
                            }}
                            className="kd-label"
                          >
                            Divine
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card chart-container">
                <div ref={answerRef} className="card-body">
                  <h3>Your Answers - The Seven Dimensions</h3>

                  {sevenDimentionForms?.map((item, i) => {
                    return (
                      <div className="mt-4 text-black" key={i}>
                        <h4 className="text-black">{item?.name}</h4>

                        <div className="mt-2">
                          <div className="font-14 text-black">
                            {item?.question.title}
                          </div>
                          <div className="font-14 text-black">
                            {_getFieldData(item?.question.id)}
                          </div>
                        </div>
                        <div className="mt-4">
                          <div className="font-14 text-black">
                            {item?.answer.title}
                          </div>
                          <div className="font-14 text-black">
                            {_getFieldData(item?.answer.id)}
                          </div>
                        </div>
                      </div>
                    );
                  })}

                  <div className="mt-5">
                    <h3>Your Answers - The Eight Aspects of Wealth</h3>
                  </div>

                  {eightAspectsForm.map((item, i) => {
                    return (
                      <div className="mt-4 text-black" key={i}>
                        <h4 className="text-black">{item.name}</h4>

                        <div className="mt-2">
                          <div className="font-14 text-black">
                            {item.question.title}
                          </div>
                          <div className="font-14 text-black">
                            {_getFieldData(item.question.id)}
                          </div>
                        </div>
                        <div className="mt-4">
                          <div className="font-14 text-black">
                            {item.answer.title}
                          </div>
                          <div className="font-14 text-black">
                            {_getFieldData(item.answer.id)}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Container-fluid Ends*/}
      </div>
    </Default>
  );
};

export default ResponseDetails;
